import { PeriodReportData } from '../fetchData/queries/PeriodReportData'

export interface ReportSnapshotIds {
  previousSnapshotId: string | null
  currentSnapshotId: string | null
}

export const getReportSnapshotIds = (
  selectedReport: PeriodReportData | null
): ReportSnapshotIds => {
  if (!selectedReport) {
    return { previousSnapshotId: null, currentSnapshotId: null }
  }

  const previousSnapshotId =
    selectedReport.snapshotReferences?.previousSnapshotReference?.snapshotId ||
    null

  const comparedRefs =
    selectedReport.snapshotReferences?.comparedWithSnapshotReferences

  const currentSnapshotId =
    comparedRefs && comparedRefs.length > 0
      ? comparedRefs[comparedRefs.length - 1].snapshotId
      : null

  return { previousSnapshotId, currentSnapshotId }
}
